module.exports = __webpack_public_path__ + "3437f7c8e34e82f3b769f1eb383246b4.png";